<div class="m-333">
  <div *ngFor="let example of examples" class="mb-24">
    <tgss-example-viewer [exampleId]="example" [path]="componentDirPath" [data]="exampleComponents[example]"></tgss-example-viewer>
  </div>
</div>